import { differenceInHours, isToday, isTomorrow, parseISO } from 'date-fns';
import { getFullName } from '@/common/utils/person';

export function formatExpiringInMessage(listingEndDate: string | null) {
  if (!listingEndDate) return '';

  const endDate = parseISO(listingEndDate);

  if (isToday(endDate)) {
    return 'Listing agreement expiring today';
  }

  if (isTomorrow(endDate)) {
    return 'Listing agreement expiring in 1 day';
  }

  const daysRemaining = Math.ceil(differenceInHours(endDate, Date.now()) / 24);

  return `Listing agreement expiring in ${daysRemaining} days`;
}

export function buildClientNames(
  contacts: {
    type: string;
    firstName?: string | null;
    lastName?: string | null;
  }[],
) {
  const client = contacts.find((contact) => contact.type === 'client');
  if (!client) return '';

  const name = getFullName(client.firstName, client.lastName);
  if (!name) return '';

  return `Client: ${name}`;
}
